import { Result } from 'antd';
import React from 'react';

import { BackButton } from '@client/components/buttons/BackButton';
import { ERoutePaths } from '@client/types';

export const AccessDeniedPage = (): React.JSX.Element => (
  <Result
    status="403"
    title="403"
    subTitle="Sorry, you are not authorized to access this page."
    extra={<BackButton route={ERoutePaths.HOME} />}
  />
);
